import Tippy from "@tippyjs/react"
import {
    NoVisibilityIcon,
    ValidateFilter,
    VisibleFilterValue,
    VisibilityIcon
} from '../../../../components/Controls/VisibleControl';
import {StickyHeader} from '../../../../components/Table/TableStyles';
import {EditedParticipation} from '../../../Partner/EditedPartner';
import {Filter} from '../../ParticipationFunctions/Filtering';
import {
    offsetOneRow,
    offsetTwoRows,
    centeredContainerStyle,
    StateStyledCell
} from '../../Styles/ParticipationTableStyles';

export function VisibleToParticipantHeader() {
    return (
        <StickyHeader style={{...offsetOneRow, width: '50px', minWidth: '50px', maxWidth: '50px'}}>
            <Tippy content="Shows which participations are visible on the dashboard">
                <span>Vis</span>
            </Tippy>
        </StickyHeader>
    );
}

export function VisibleToParticipantFilter({
    filter,
    updateFilter
}: {
    filter: Filter;
    updateFilter: (filter: Filter) => void;
}) {
    return (
        <StickyHeader style={{...offsetTwoRows, ...centeredContainerStyle}}>
            <ValidateFilter
                value={filter?.VisibleToParticipant ?? VisibleFilterValue.Unset}
                onChange={(e) => updateFilter({...filter, VisibleToParticipant: e.value})}
            />
        </StickyHeader>
    );
}

export function VisibleToParticipantContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell editStatus={ppn.EditStatus}>
			{ppn.VisibleToParticipant && <VisibilityIcon />}
			{!ppn.VisibleToParticipant && <NoVisibilityIcon />}
		</StateStyledCell>
	)
}